import React, { createContext, useState, useEffect, useContext } from "react";
import { node } from 'prop-types'
import useLocalStorage from "../hooks/useLocalStorage";
import { ValidateLogin } from "../contexts/ValidateLogin";
import api from '../services/api'
import { BannerJson } from "../helpers/formaterBanner";

export const development = process.env.NODE_ENV === "development" || window.location.href.includes("homolog-master");
export const previewPage = window.location.href.includes("/preview");


export const AuthValidatorContext = createContext();

export const AuthContext = ({ children }) => {
  const [ signed, setSigned] = useState(null);
  const [ userLocalStorage, setUserLocalStorage ] = useLocalStorage('@login-replicate/user', null);
  const [ tokenLocalStorage, setTokenLocalStorage ] = useLocalStorage('@login-replicate/token', null);
  const [ , setProductsLocalStorage ] = useLocalStorage('@login-replicate/products', null);
  const [ client, setClient ] = useState(userLocalStorage ? userLocalStorage.company : '');
  const [ auth, setAuth ] = useState(true);
  const [ allowPack, setAllowPack ] = useState(true);
  const [ roles, setRoles ] = useState({
    ia_resources: 0,
    compliance: 0
  });

  useEffect(() => {
    if(previewPage !== true) {
      if (auth) {
        console.log('development')
        console.log(development)
        if (development) {
          const fetchBusinessesSigned = () => {
            setSigned(true);
            setRoles({
              ia_resources: 1,
              compliance: 1
            });
          }
          fetchBusinessesSigned();
        } else {
          try {
            const getJwt = async () => {
              const data = await ValidateLogin(tokenLocalStorage);
              if (!data.auth) {
                notAuthorize();
              } else {
                if (data.type === "url") {
                  setTokenLocalStorage(data.token);
                  try {
                    // var url = window.location.href.split("?token=");
                    // if (url.length > 1) window.location.replace(url[0]);
                    setSigned(data.auth);
                  } catch (error) { setSigned(data.auth) }
                } else {
                  setSigned(data.auth);
                }
                // data.roles.ia_resources = 0;
                // data.roles.compliance = 0;
                console.log('data')
                console.log(data)
                setRoles(data.roles);
                setClient(data.user.company);
                setUserLocalStorage(data.user);
              }
            };
            getJwt();
          } catch (error) {
            notAuthorize();
          }
        }
        const fetchBusinessesAuth = () => {
          setAuth(false);
        }
        fetchBusinessesAuth();
          
      }
    }
  });
  
  async function recordHash(master, replicas, type) {
    if (development) return { allowed_access: true };
		try {
      var allowed_access = { allowed_access: true };
      const master_json = BannerJson(master, type, true);
			const resMaster = await post_hash(master_json);
      allowed_access = resMaster;
      // if (!resMaster) return false;

      for (var i = 0; i < replicas.length; i++) {    
        const replica_json = BannerJson(replicas[i], type, false);
        const resReplica = await post_hash(replica_json);
        allowed_access = resReplica;
        // if (!resReplica) return false
      }
      return allowed_access;
		} catch (e) {
			console.log(e)
			return { allowed_access: false };
		}
  }

  async function post_hash(data) {
    try {
      data.product = "83073720-75dc-4a1c-ab99-3a8562b83d4c";
      const json = JSON.stringify(data);
      api.defaults.headers.Authorization = `Bearer ${tokenLocalStorage}`;
      const response = await api.post('/products/tracker', json, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return { allowed_access: response.data.allowed_access };
		} catch (e) {
			return { allowed_access: false };
    }
  }

  function notAuthorize() {
    setTokenLocalStorage(null);
    setUserLocalStorage(null);
    setSigned(false);
    window.location.replace("https://www.reanimateads.com.br/");
  }

	return (
    <AuthValidatorContext.Provider
      value={{
        signed, setSigned, 
        userLocalStorage, setUserLocalStorage,
        tokenLocalStorage, setTokenLocalStorage,
        setProductsLocalStorage,
        auth, setAuth,
        recordHash, roles, setRoles, allowPack, setAllowPack, client, setClient
      }}
    >
      {children}
    </AuthValidatorContext.Provider>
  );
}

AuthContext.propTypes = {
  children: node.isRequired
}
